module.exports = __webpack_public_path__ + "static/media/1280x720.e3e87b01.jpg";